import { onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";
import NotaDb from "../../../../db/notaDb";
import felixAnalytics from "../../../../felixAnalytics";
import { Negociacao } from "../../../../models/enum";
import { NotaBMF, NotaBovespa } from "../../../../models/nota";
import { useUsuario } from "../../../../providers/usuarioProvider";
import Bmf from "./bmf/bmf";
import Bovespa from "./bovespa/bovespa";
import { useParams } from "react-router-dom";

export default function Nota() {
  const { notaId } = useParams();

  const { visualizado } = useUsuario();
  const [nota, setNota] = useState<NotaBovespa | NotaBMF>();

  useEffect(() => {
    if (!!visualizado) {
      felixAnalytics.identify(visualizado);
      felixAnalytics.track("pageview", { pagina: "nota" });
    }
  }, [visualizado]);

  useEffect(() => {
    if (!!visualizado && !!notaId && notaId !== "nova") {
      return onSnapshot(
        new NotaDb().doc({ usuarioId: visualizado, notaId }),
        (doc) => setNota(doc.data())
      );
    }
  }, [visualizado, notaId]);

  if (notaId !== "nova" && !nota) return <></>;
  if (nota?.tipoNegociacao === Negociacao.BOVESPA || notaId === "nova") {
    return <Bovespa nota={nota as NotaBovespa} nova={notaId === "nova"} />;
  } else {
    return <Bmf nota={nota as NotaBMF} />;
  }
}
